import { render, staticRenderFns } from "./huovRebook.vue?vue&type=template&id=bec1aeb6"
import script from "./huovRebook.vue?vue&type=script&lang=js"
export * from "./huovRebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports